(function (Drupal, $) {
  Drupal.behaviors.view_more = {
    attach: function attach(context) {
      $(context).find('#personnel-view-more').click(function () {
        // Hide the button
        $(this).hide();
        // Show the previously hidden content
        $('.display\\@sm').removeClass('display@sm');
        // Show the Denny's Board because it doesn't' have the class set on it like above
        $('.personnel:last-of-type').show();
      });

      $(context).find('.menu-view-more-button').click(function () {
        // Hide the button
        $(this).hide();
        // Show the previously hidden content items
        $(this).siblings('.display\\@lg').removeClass('display@lg');
      });

      $(context).find('.den-menu__view__view-more').click(function () {
        // Hide the button
        $(this).hide();
        // Show the previously hidden content items
        $(this).siblings('.display\\@lg').removeClass('display@lg');
      });
    }
  }
})(Drupal, jQuery);
